import React, { useState } from "react";
import { menuList } from "../../data/menuList";
import DesctopMenuItem from "./DesctopMenuItem";
import "./desctopMenu.scss";
import { useLocation, useNavigate } from "react-router-dom";

const DesctopMenu = () => {
    const location = useLocation();
    const navigane = useNavigate();

    const [showSubMenuItems, setShowSubMenuItems] = useState(0);

    const toggleSubmenuItemHandler = (id, link, name) => {
        if (link) {
            navigane(link);
            setShowSubMenuItems(0);
        }
        if (showSubMenuItems === id) {
            setShowSubMenuItems(0);
        } else {
            setShowSubMenuItems(id);
        }
    };

    return (
        <div className="desctop-menu">
            <div className="desctop-menu__list">
                {menuList.map((menuItem) => {
                    return (
                        <DesctopMenuItem
                            key={menuItem.id}
                            menuItem={menuItem}
                            location={location}
                            showSubMenuItems={showSubMenuItems}
                            setShowSubMenuItems={setShowSubMenuItems}
                            toggleSubmenuItemHandler={toggleSubmenuItemHandler}
                        />
                    );
                })}
            </div>
            <div className="desctop-menu__divider"></div>
        </div>
    );
};

export default DesctopMenu;
